exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message_text{font-size:1rem;font-weight:400;color:#333;margin:30px 25px}.message__btngrounp{text-align:center;padding-bottom:5px}.message__btnGrounp-btn{min-width:75px;font-size:1rem;color:#777;margin-left:10px}.message_hr_line{border-top:1px solid #ccc;margin-bottom:6px;margin-top:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Foundation/components/MessageForm/style.css
 ** module id = 963
 ** module chunks = 1 10 30
 **/